module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAABBUlEQVRYCe2QMYqEQBBF/4g3EMFEES8iiAgeyXMZioHgKYwEGzMjIxV1qVlsbHB3oINigjbpqmp/P+q9hBBnVVXoug5cXxiGSJIEFoG3bePivjn7vqMsS9icG18bDsPwLu1rQKfneYjjGFEU3ceyplDbtuj7Xs6uQidrXWE6/wPTve/7yLLsHpG1TlaB/7WxJABwHOfeylonq8DlS0yFgTOJVjFGu+qDqTPamUSrGKNd9cHUGe1MolWM0a76YOq+R/s4jh93nuf58R+drLJ50zSYpunxcRoSuK7rx3ud7KsoivPxNYahHQQBjuOAEIIB94twXRfrusJK0xTLsrCBCUTgPM/xAxX/Y3PFu2cxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common-icons/vertical-split.png
// module id = VbFI
// module chunks = 1